export default {
  path: '/statement',
  component: () => import('@/views/stateMent/statement-router.vue'),
  children: [
    {
      path: 'sales-report',
      name: 'SalesReport',
      component: () => import('@/views/stateMent/pages/SalesReport.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: 'customer-report',
      name: 'CustomerReport',
      component: () => import('@/views/stateMent/pages/CustomerReport.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: 'package-report',
      name: 'PackageReport',
      component: () => import('@/views/stateMent/pages/PackageReport.vue'),
      meta: {
        auth: true
      }
    }

  ]
}
